import { useForkRef as t } from "../../../ariakit-react-utils/esm/hooks.js";
import { createHook as n, createComponent as p, createElement as c } from "../../../ariakit-react-utils/esm/system.js";
const s = n((e) => {
  let {
    state: r,
    ...o
  } = e;
  return o = {
    ...o,
    ref: t(r.anchorRef, o.ref)
  }, o;
}), m = p((e) => {
  const r = s(e);
  return c("div", r);
});
process.env.NODE_ENV !== "production" && (m.displayName = "PopoverAnchor");
export {
  m as PopoverAnchor,
  s as usePopoverAnchor
};
//# sourceMappingURL=popover-anchor.js.map
